import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import API from 'utils/atolyeAPI';
import alert from 'js/sweetAlert';
import { START_LOADING, STOP_LOADING } from '../singlePriceOfferSlice';

const AtolyeAPI = new API();

const DeletePriceOfferModal = () => {
  //Redux
  const dispatch = useDispatch();
  const { priceOffer } = useSelector((state) => state.priceOffers.singlePriceOffer);

  // Hooks
  const navigate = useNavigate();

  // Functions
  const deletePriceOfferHandler = async () => {
    dispatch(START_LOADING());
    try {
      await AtolyeAPI.get(`/price_offers/${priceOffer.id}/delete`);
      alert('success', 'Fiyat Teklifi başarıyla silindi');
      navigate('/price-offers');
    } catch (error) {
      alert('error', 'Fiyat Teklifi silinirken bir hata oluştu');
      console.log(error);
    } finally {
      dispatch(STOP_LOADING());
    }
  };

  return (
    <div
      className="modal fade delete-order-modal-lg"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered ">
        <div
          className="modal-content"
          style={{
            backgroundImage: 'linear-gradient(to top, #dfe9f3 0%, white 100%)',
          }}>
          <div className="modal-header">
            <h5 className="modal-title">Teklifi Sil</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <p>
              <strong>{priceOffer.id}</strong> numaralı teklifi silmek istediğinize emin misiniz?
            </p>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              data-toggle="modal"
              data-dismiss="modal"
              onClick={deletePriceOfferHandler}>
              Sil
            </button>
            <button type="button" className="btn btn-secondary" data-dismiss="modal">
              Vazgeç
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletePriceOfferModal;
